import { Badge } from "@website/ui/badge";
import { useTabButton } from "@website/ui/tab-button/tab-button.hook";
import styles from "@website/ui/tab-button/tab-button.module.scss";
import { TabButtonPropertiesType } from "@website/ui/tab-button/tab-button.types";
import { FC, memo } from "react";

const TabButton: FC<TabButtonPropertiesType> = (properties) => {
  const {
    badge,
    description,
    disabled,
    Wrapper,
    Icon,
    title,
    selected,
    variant = "contained",
    color = "primary",
    iconPosition = "top",
    behavior = "button",
    size = "content"
  } = properties;

  const { buttonProperties, linkProperties } = useTabButton(properties);

  const wrapperClassName = `${styles["tab-button"]} ${styles[variant]} ${
    styles[size]
  } ${iconPosition === "side" ? styles["side-icon"] : styles["top-icon"]} ${
    styles[color]
  } ${disabled ? styles["disabled"] : ""} ${
    selected ? styles["selected"] : ""
  }`;

  const content = (
    <>
      {Icon ? <div className={styles["button-icon"]}>{Icon}</div> : null}
      <div className={styles["button-content"]}>
        <div className={styles["button-middle"]}>
          <div className={styles["button-title"]}>{title}</div>
          {badge ? <Badge color={color} content={badge} /> : null}
        </div>
        {description ? (
          <div className={styles["button-description"]}>{description}</div>
        ) : null}
      </div>
    </>
  );

  if (behavior === "link") {
    return (
      <a {...linkProperties} className={wrapperClassName}>
        {content}
      </a>
    );
  }
  if (behavior === "custom" && Wrapper) {
    return (
      <Wrapper {...linkProperties} className={wrapperClassName}>
        {content}
      </Wrapper>
    );
  }
  return (
    <button {...buttonProperties} className={wrapperClassName}>
      {content}
    </button>
  );
};

const TabButtonMemoized = memo(TabButton);
export { TabButtonMemoized as TabButton };
